import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Grid } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import Logo from '../../../assets/LWT_Logo.svg';

const Footer = (): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation('Footer');

  return (
    <Box component="footer" displayPrint="none" className={classes.footerContainer}>
      <Grid container className={classes.footer}>
        <Grid item xs={12} lg>
          <img src={Logo} alt={t('Learning Without Tears Logo')} className={classes.logo} />
        </Grid>
        <Grid container item xs={12} lg alignItems="center" className={classes.textContainer}>
          <Grid item>
            <a
              href="https://www.lwtears.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(classes.text, classes.link)}
            >
              {t('Privacy Policy')}
            </a>
          </Grid>
          <Divider flexItem orientation="vertical" variant="middle" className={classes.divider} />
          <Grid item>
            <a
              href="https://www.lwtears.com/terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(classes.text, classes.link)}
            >
              {t('Terms of Service')}
            </a>
          </Grid>
          <Divider flexItem orientation="vertical" variant="middle" className={classes.divider} />
          <Grid item>
            <span className={classes.text}>{t('Copyright © 2026')}</span>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  footerContainer: {
    bottom: 0,
    zIndex: theme.zIndex.drawer
  },
  footer: {
    background: '#2e2e2e',
    paddingTop: theme.spacing(1.275),
    paddingRight: theme.spacing(12),
    paddingBottom: theme.spacing(1.275),
    paddingLeft: theme.spacing(5),
    position: 'relative',
    '@media screen and (max-width: 650px)': {
      paddingRight: theme.spacing(2.5),
      paddingLeft: 0,
    }
  },
  logo: {
    display: 'block',
    height: 50,
    width: 260,
    bottom: 0,
    left: -58,
    position: 'absolute',
    '@media screen and (max-width: 500px)': {
      top: -5.62,
    }
  },
  textContainer: {
    alignContent: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    display: 'flex',
    minWidth: 0,
    '@media screen and (max-width: 500px)': {
        marginTop: theme.spacing(5),
        justifyContent: 'center',
    }
  },
  text: {
    ...theme.typography.body1,
    color: 'white',
    textDecoration: 'none',
    fontSize: theme.typography.subtitle2.fontSize
  },
  link: {
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  divider: { backgroundColor: 'white' }
}));

export default Footer;
